import React from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { useNavigation } from '../contexts/NavigationContext';

const AdminFloatingActionButton = ({ 
  setNewAppointmentModalOpen, 
  setMobileAppointmentModalOpen,
  setNewServiceModalOpen, 
  setNewProfessionalModalOpen 
}) => {
  // Usar o hook de navegação para acessar o contexto
  const { activeTab } = useNavigation();
  
  // Definir ação do botão com base na tab ativa
  const handleButtonClick = () => {
    switch (activeTab) {
      case 'appointments':
        console.log('Abrindo modal de novo agendamento mobile');
        setMobileAppointmentModalOpen(true);
        break;
      case 'professionals':
        setNewProfessionalModalOpen(true);
        break;
      default:
        // Sem ação para outras tabs
        break;
    }
  };

  // Verificar se devemos mostrar o botão para a tab atual
  // Remover o botão da interface mobile para a seção de serviços
  const shouldShowButton = ['appointments', 'professionals'].includes(activeTab);

  if (!shouldShowButton) return null;

  return (
    <div className="fixed right-4 bottom-20 md:hidden z-20">
      <button 
        onClick={handleButtonClick}
        className="bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-lg p-4"
        aria-label={
          activeTab === 'appointments' ? 'Novo Agendamento' :
          activeTab === 'professionals' ? 'Novo Profissional' : 'Nova Entrada'
        }
      >
        <PlusIcon className="w-6 h-6" />
      </button>
    </div>
  );
};

export default AdminFloatingActionButton; 